import { Action } from 'redux';
import { SET_FROZEN_ENTITY_ACTION, SetFrozenEntityIdAction } from './actions';

const initialState: string | null = null;

export const frozenEntityIdReducer = (
  state: string | null | undefined,
  action: Action,
): string | null => {
  if (!state) {
    state = initialState;
  }

  if (action.type === SET_FROZEN_ENTITY_ACTION) {
    return (action as SetFrozenEntityIdAction).payload;
  }

  return state;
};
